import { Configuration, IConfiguration } from './domain/conf'
import { Page } from './domain/page'
import { AdService, IAdTargetingConfig } from './services/ads'
import { WithAmazonBidding } from './services/ads/adapters/amazon'
import { WithDistrictMBidding } from './services/ads/adapters/district-m'
import { WithDistrictMExpressBidding } from './services/ads/adapters/district-m-express'
import { GPTAdapter } from './services/ads/adapters/google-publisher-tag'
import { WithIndexExchangeBidding } from './services/ads/adapters/index-exchange'
import { WithIntegralAdScience } from './services/ads/adapters/integral-ad-science'
import { WithKrux } from './services/ads/adapters/krux'
import { WithSortableBidding } from './services/ads/adapters/sortable'
import { defaultAdURIFormatter } from './services/ads/formatters/default'
import { WithRefresh } from './services/ads/refresh'
import { DefaultAdTargetingStrategy } from './services/ads/targeting/default'
import { AdTargetLookup } from './services/ads/targeting/lookup'
import { AgeGateService } from './services/age-gate'
import { PageAgeGateService } from './services/age-gate/page'
import { AnalyticsService } from './services/analytics'
import { EventAdapter } from './services/analytics/adapters/events'
import { DefaultAnalyticsFormatter } from './services/analytics/formatters/default'
import { TagManager } from './services/analytics/tags'
import { ConsentBannerService } from './services/consent-banner'
import { IdentityService } from './services/identity'
import { JanrainAdapter } from './services/identity/adapters/janrain'
import { WithPiano } from './services/identity/adapters/piano'
import { WithViafoura } from './services/identity/adapters/viafoura'
import { GlobalStore } from './utils/storage/global'
import { Store } from './utils/storage/keys'

export const initPage = (conf: IConfiguration) =>
    new Page(
        new Configuration(conf),
        new (WithRefresh(AdService))(
            new (WithKrux(
                    WithSortableBidding(
                        WithIndexExchangeBidding(
                            WithIntegralAdScience(
                                WithDistrictMBidding(
                                    WithDistrictMExpressBidding(
                                        WithAmazonBidding(GPTAdapter))))))))(),
            defaultAdURIFormatter,
            new DefaultAdTargetingStrategy(AdTargetLookup)),
        new AgeGateService(),
        new PageAgeGateService(),
        new ConsentBannerService(),
        new AnalyticsService(
            new EventAdapter(),
            new DefaultAnalyticsFormatter(),
            new TagManager()),
        new IdentityService(
            new (WithViafoura(
                    WithPiano(JanrainAdapter)))()
        ))

/**
 * Returns Ad Targeting Config  (To be used in Youtube Player)
 */
export  const getAdTargetingConfig = (configuration: IConfiguration): IAdTargetingConfig => {
    const conf = new Configuration(configuration)
    const adService = new AdService(
                        new (WithKrux(
                                WithIndexExchangeBidding(
                                    WithIntegralAdScience(
                                        WithDistrictMBidding(
                                            WithAmazonBidding(GPTAdapter))))))(false),
                        defaultAdURIFormatter,
                        new DefaultAdTargetingStrategy(AdTargetLookup))

    return adService.getTargeting({
        ancestry: conf.page.ancestry,
        articleId: conf.page.articleId,
        bidding: conf.ads.bidding,
        negative: conf.page.klangoo ? conf.page.klangoo.negativeKeywords : undefined,
        network: conf.ads.network,
        originId: conf.page.originId,
        page: conf.page.type,
        pageConfig: conf.page,
        property: conf.ads.property,
        provider: conf.ads.provider,
        refresh: conf.ads.refresh,
        sensitive: conf.page.klangoo ? conf.page.klangoo.sensitiveContent : undefined,
        siteId: conf.ads.site,
        tagManagers: conf.ads.tags,
        verifier: conf.ads.verifier,
        writers: conf.page.writers
    })

}
export { GlobalStore, Store }
